module.exports = __webpack_public_path__ + "img/card_ip_stipulation6.c804f0fb.svg";